import { Order } from '@/interfaces';
import { InvoiceComponent } from '@/screen/InvoiceComponent';
import apiService from '@/service';
import { createFileRoute, useRouter } from '@tanstack/react-router'
import { useEffect, useState } from 'react';

// Define the search schema
const searchSchema = {
  print: (value: any) => value === true || value === 'true' || false
}

export const Route = createFileRoute('/(app)/(store)/order/$orderId/')({
  loader: async ({ params }) => {
    const { data: order } = await apiService.get<Order>(
      "v1/order/" + params.orderId, {
      "seller-product-detail": "true",
      "seller-store-detail": "true",
    }
    );
    return order
  },
  validateSearch: searchSchema,
  component: RouteComponent
})

function RouteComponent() {
  const order = Route.useLoaderData()
  const router = useRouter();
  const { print } = Route.useSearch();
  const [shouldAutoPrint, setShouldAutoPrint] = useState(false);

  const handleOrderUpdated = () => {
    router.invalidate();
  };

  // Auto-trigger print if print parameter is true and hasn't been printed yet
  useEffect(() => {
    
    if (print) {
      // Check if we've already auto-printed for this order in this session
      const hasPrintedBefore = sessionStorage.getItem(`auto-printed-${order._id}`);
      
      if (!hasPrintedBefore) {
        sessionStorage.setItem(`auto-printed-${order._id}`, 'true');
        setShouldAutoPrint(true);
        
        // Clear the print parameter from URL to prevent re-triggering on refresh
        const timeoutId = setTimeout(() => {
          router.navigate({
            to: '/order/$orderId',
            params: { orderId: order._id },
            search: { print: undefined },
            replace: true
          });
        }, 1000);
        
        return () => clearTimeout(timeoutId);
      } else {
        // Clear the print parameter if already printed
        router.navigate({
          to: '/order/$orderId',
          params: { orderId: order._id },
          search: { print: undefined },
          replace: true
        });
      }
    }
  }, [print, order._id, router]);


  return (
    <InvoiceComponent 
      order={order} 
      onOrderUpdated={handleOrderUpdated} 
      autoPrint={shouldAutoPrint}
    />
  );
}